import styles from '../../styles/retailers.module.scss';

import { gql } from '@apollo/client';
import { Image, TextField, Button } from '@aws-amplify/ui-react';
import { useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Loader } from '@aws-amplify/ui-react';

import {
  validateEmail,
  handleEnterKeySubmit,
  getRegions,
  appendStoreLocatorComponent,
  getRetailersUnorderedList,
  captureException,
  getReferralLink,
} from '../../utils/commons';
import { getUserLocation, isUserInsideOfferArea } from '../../utils/locations';
import { ICampaign, ICampaignCustomQuestion } from '../../models/Campaign';
import {
  getCampaignDetails,
  getCampaignQuestions,
  hasUserCompletedAssociatedCampaigns,
} from '../../utils/graphql/queries';
import { ICampaignLandBotData } from '../../models/LandBot';
import { getFollowupCode } from '../../utils/commons';
import { backendConfig } from '../../config/backendConfig';
import { IUserLocation } from '../../models/Location';
import { client } from '../../utils/apollo';

import * as fbq from '../../utils/fpixel';
import Slider from 'react-slick';
import PhotoIcon from '../../assets/photoIcon';
import noImage from '../../assets/no_image.png';
import BagIcon from '../../assets/bagIcon';
import DollarIcon from '../../assets/dollarIcon';
import supertokens from 'supertokens-node';
import Session from 'supertokens-node/recipe/session';
import StepCard from '../../components/stepCard';
import Custom404 from '../../components/custom404';
import Navbar from '../../components/navbar';
import LandbotComponent from '../../components/landbot';
import ThirdPartyPasswordlessNode from 'supertokens-node/recipe/thirdpartypasswordless';
import { IFontStyle } from '../../models/Fonts';
import PlainModal from '../../components/PlainModal';

//TODO: Test Shopify stuff

const Campaigns = ({ campaignData, campaignQuestions, authenticatedEmail, userIp }: PropTypes) => {
  const [showLandBot, setShowLandBot] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [offerIsOver, setOfferIsOver] = useState(false);
  const [isOfferLive, setIsOfferLive] = useState(true);
  const [userInsideOfferArea, setUserInsideOfferArea] = useState(false);
  const [userLocationInfo, setUserLocationInfo] = useState<IUserLocation>({} as IUserLocation);
  const [invalidInput, setInvalidInput] = useState(false);
  const [isDesktopView, setIsDesktopView] = useState(false);
  const [fontStyle, setFontStyle] = useState<IFontStyle>();
  const [showAssociatedCampaignsCompletedModal, setShowAssociatedCampaignsCompletedModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const router = useRouter();
  const followupCode = getFollowupCode();
  const timeZone = new Date().getTimezoneOffset();
  const abortController = useRef(new AbortController());
  const baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL;

  const signal = abortController.current?.signal;
  const { query } = router;
  // Assuming 'r' is your query string key for the retailer id
  const retailerIdQuery = router.query.r;
  // Ensure the query param is treated as a single string. If it's an array, take the first value.
  const retailerId = Array.isArray(retailerIdQuery) ? retailerIdQuery[0] : retailerIdQuery;

  // Now, filter the retailers based on the retailerId from the URL, ensuring both values are compared in the same case (lowercase for example)
  const filteredRetailers = campaignData.Retailers.filter((item) =>
    // Check if retailerId is present; if so, perform the filter, otherwise return true to include all retailers
    retailerId ? item.Id.toLowerCase() === retailerId.toLowerCase() : true
  );
  const retailersUl = getRetailersUnorderedList(campaignData, filteredRetailers);

  let refferal: string = '';
  let utmSource: string = '';
  let utmCampaign: string = '';

  if (query.spref) {
    refferal = String(query.spref);
    console.log(`referred by: ${query.spref}`);
  }

  utmSource = String(query?.utm_source || '');
  utmCampaign = String(query?.utm_campaign || '');

  const slick_settings = {
    infinite: true,
    centerPadding: '5px',
    slidesToShow: filteredRetailers.length >= 3 ? 3 : filteredRetailers.length,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    cssEase: 'linear',
    arrows: false,
  };

  let campaignOfferRequirement = campaignData?.RebateRequirement;

  switch (campaignOfferRequirement) {
    case '1':
      campaignOfferRequirement = 'one';
      break;
    case '2':
      campaignOfferRequirement = 'two';
      break;
    case '3':
      campaignOfferRequirement = 'three';
      break;
    default:
      break;
  }

  const customChatBotData: ICampaignLandBotData = {
    utm_source: utmSource,
    utm_campaign: utmCampaign,
    current_ip: userLocationInfo?.ip || userIp,
    location_city: userLocationInfo?.city,
    location_state: userLocationInfo?.state,
    location_zip: userLocationInfo?.zip,
    location_latitude: userLocationInfo?.lat || 0,
    location_longitude: userLocationInfo?.long || 0,
    timezone: timeZone,
    botid: campaignData?.BotId,
    campaignid: campaignData?.CampaignId,
    campaign_description: campaignData?.CampaignDescription,
    companyname: campaignData?.BrandName,
    companyurl: campaignData?.BrandUrl,
    company_instagram: campaignData?.BrandInstagramUrl,
    company_logo: campaignData?.LogoImage,
    company_logo_wide: campaignData?.LogoImageWide,
    company_retaillocations_url: campaignData?.BrandRetailLocationsUrl,
    company_recipes_url: campaignData?.BrandRecipesUrl,
    campaign_dtc: campaignData?.DtcOnly,
    campaign_dtc_with_receipt: campaignData?.DtcWithReceipt,
    campaign_product_name: campaignData?.ProductName,
    campaign_product_name_dtc: campaignData?.ProductNameDtc,
    campaign_product_url: campaignData?.ProductUrl,
    campaign_offer: campaignData?.RebateAmount + ' off',
    campaign_offer_requirement: campaignOfferRequirement,
    campaign_offer_requirement_timegate: campaignData?.RebateRequirementTimegate,
    campaign_enddate: campaignData?.EndDate,
    campaign_followup_offer: campaignData?.FollowupOffer,
    campaign_followup_product_name: campaignData?.ProductName,
    campaign_followup_redemptionurl: campaignData?.FollowupOfferRedemptionUrl,
    campaign_followup_amount: campaignData?.FollowupRebateAmount,
    campaign_followup_requirement: campaignData?.FollowupRebateRequirement,
    campaign_followup_enddate: campaignData?.FollowupEndDate,
    campaign_legal_text: campaignData?.LegalText,
    campaign_restrict_by_referrer: campaignData?.RestrictByReferrer,
    campaign_valid_referrer: campaignData?.ValidReferrerString,
    redemption_email_image: campaignData?.EmailImage,
    email: userEmail,
    participating_retailers: filteredRetailers,
    instore_location: campaignData?.InStoreLocation,
    followup: followupCode,
    campaign_buttoncolor: campaignData?.ButtonColor,
    campagain_buttontextcolor: campaignData?.ButtonTextColor,
    campaign_extendedredemptions: campaignData?.ExtendedRedemptions,
    campaign_extendedredemptions_enddate: campaignData?.ExtendedRedemptionsEndDate,
    campaign_storefinder_url: campaignData?.BrandRetailLocationsUrl,
    campaign_usebatchmethod: campaignData.UseBatchMethod,
    campaign_initial_offer: campaignData?.InitialOffer,
    campaign_initial_offer_rebate_amount: campaignData?.RebateAmount,
    campaign_use_accelerated_flow: String(campaignData?.UseAcceleratedFlow),
    redemption_custom_message: '',
    redemption_cap_buffer: campaignData?.RedemptionCapBuffer,
    redemption_locations_ul: retailersUl,
    redemption_questions: campaignData?.RedemptionQuestions,
    redemption_questions_review: campaignData?.RedemptionQuestionsReview,
    redemption_questions_customquestion: campaignData?.RedemptionQuestionsCustomQuestion,
    redemption_questions_customlabel: campaignData?.RedemptionQuestionsCustomLabel,
    redemption_questions_customvalues: campaignData?.RedemptionQuestionsCustomValues,
    offerid: campaignData?.CampaignId,
    chatConfigId: campaignData?.ChatConfigId + '/index.json',
    backgroundImage: campaignData?.BackgroundImage,
    chatButtonColor: campaignData?.ChatButtonColor,
    chatButtonTextColor: campaignData?.ChatButtonTextColor,
    shopifyStorefrontUrl: campaignData?.ShopifyStorefrontUrl,
    shopifyStorefrontToken: campaignData?.ShopifyStorefrontToken,
    shopifyProductId: campaignData?.ShopifyProductId,
    DtcOnly: campaignData.DtcOnly,
    instore_location_image: campaignData?.InStoreLocationImage,
    referral: refferal,
    skip_landing_intro: campaignData?.SkipLandingIntro?.toString(),
    brandAmbassodorId: String(query.ba_id) || '',
    fieldAgents: campaignData?.FieldAgents,
    referral_link: getReferralLink(
      baseUrl || 'https://offers.trysampoll.com',
      campaignData?.CampaignId,
      campaignData?.RestrictByReferrer,
      campaignData?.ValidReferrerString,
      retailerId
    ),
    // Below fields are temporary, will be removed once we integrate fieldAgents dynamically
    fieldagent_id: campaignData?.FieldAgents?.length ? campaignData?.FieldAgents[0].Id : null,
    fieldagent_reward: campaignData?.FieldAgents?.length ? campaignData?.FieldAgents[0].Reward : null,
    fieldagent_requirement_1_id:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[0].Id) ||
      null,
    fieldagent_requirement_1:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[0].Description) ||
      null,
    fieldagent_requirement_1_question:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[0].ResponseQuestion) ||
      null,
    fieldagent_requirement_1_questiontype:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[0].ResponseQuestionType) ||
      null,

    fieldagent_requirement_2_id:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[1].Id) ||
      null,
    fieldagent_requirement_2:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[1].Description) ||
      null,
    fieldagent_requirement_2_question:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[1].ResponseQuestion) ||
      null,
    fieldagent_requirement_2_questiontype:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[1].ResponseQuestionType) ||
      null,

    fieldagent_requirement_3_id:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[2].Id) ||
      null,
    fieldagent_requirement_3:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[2].Description) ||
      null,
    fieldagent_requirement_3_question:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[2].ResponseQuestion) ||
      null,
    fieldagent_requirement_3_questiontype:
      (campaignData?.FieldAgents?.length &&
        campaignData?.FieldAgents[0].Requirements.length &&
        campaignData?.FieldAgents[0].Requirements[2].ResponseQuestionType) ||
      null,

    fieldagent_isactive: campaignData?.FieldAgents?.length ? campaignData?.FieldAgents[0].IsActive : null,
    is_sweepstakes: campaignData?.IsSweepstakes ? 1 : 0,
    campaign_custom_questions: campaignQuestions,
  };

  const offersClaimed = Math.floor(
    ((campaignData.StartingInventory - campaignData.RemainingInventory) / campaignData.StartingInventory) * 100
  );

  useEffect(() => {
    if (campaignData?.FacebookPixel) {
      fbq.initPixel(campaignData.FacebookPixel);
      console.log('initializing custom pixel: ' + campaignData.FacebookPixel);
      //fbq.eventSingle('PageView', campaignData.FacebookPixel); // Fire the PageView event for the dynamic pixel
    }
  }, [campaignData.FacebookPixel]);

  useEffect(() => {
    const now = new Date().toISOString();

    if (campaignData.StartDate > now) setIsOfferLive(false);
    if (offersClaimed > 99 || campaignData.EndDate < now || campaignData.IsActive === false) setOfferIsOver(true);
  }, [offersClaimed, campaignData.EndDate, campaignData.StartDate, campaignData.IsActive]);

  const barStyle = {
    width: `${offersClaimed > 100 ? 100 : offersClaimed}%`,
    backgroundColor: `${campaignData.ButtonColor}`,
  };

  useEffect(() => {
    function handleKeyPress(event: any) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitButtonRef.current?.click();
      }
    }

    document.addEventListener('keypress', handleKeyPress);
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, []);

  useEffect(() => {
    if (campaignData.BrandRetailLocationsScript && retailerIdQuery == undefined) {
      appendStoreLocatorComponent(campaignData.BrandRetailLocationsScript);
    }
  }, [campaignData.BrandRetailLocationsScript]);

  useEffect(() => {
    const root = document.documentElement;
    root?.style.setProperty('--custom-background', campaignData.ButtonColor);
  }, [campaignData.ButtonColor]);

  //When we first load we need to try and get user location..
  useEffect(() => {
    const getUserLocationOnLoad = async () => {
      try {
        const location = await getUserLocation(false, signal, userIp);
        //if ipstack didn't return a value for ip address then use the value we got directly from the browser instead.
        if (!location?.ip) {
          location.ip = userIp;
          //get geographic information from ip address somehow OR find better way to geolocate user and fill out other location properties
        }
        setUserLocationInfo(location);
      } catch (err) {
        if (err instanceof Error && err.message !== 'Operation was aborted') captureException(err);
      }
    };

    getUserLocationOnLoad();
  }, [campaignData.DMA, signal]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1200px)');

    const handleMediaQueryChange = (e: any) => {
      setIsDesktopView(e.matches);
    };

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    setIsDesktopView(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  async function buttonSubmitHandler() {
    setUserEmail(userEmail.trim());
    const emailIsValid = validateEmail(authenticatedEmail || userEmail);

    const handleLocationAndOfferArea = async () => {
      if (!userLocationInfo.lat) {
        //console.log('aborting getBrowserLocation...');
        abortController.current.abort();
        const location = await getUserLocation(true, null, userIp);
        setUserLocationInfo(location);
      }
      const isAllowed = isUserInsideOfferArea(userLocationInfo.state, campaignData.DMA);
      setUserInsideOfferArea(isAllowed);

      if (!userInsideOfferArea && campaignData.DMA.length > 0) {
        const regions = getRegions(campaignData.DMA);
        alert(`This offer is only redeemable in the following regions:\n${regions.join(' ')}`);
      }
      setShowLandBot(true);
    };

    if (emailIsValid) {
      console.log('Email is valid');

      if (campaignData.BlockAssociatedCampaigns && campaignData.AssociatedCampaigns.length) {
        setIsLoading(true);
        const resp = await hasUserCompletedAssociatedCampaigns(
          client,
          gql,
          authenticatedEmail || userEmail,
          campaignData.AssociatedCampaigns || []
        );
        setIsLoading(false);
        if (resp?.data?.isCampaignCompletedByUser) return setShowAssociatedCampaignsCompletedModal(true);
      }

      await handleLocationAndOfferArea();
      fbq.event('Contact');
    } else if (campaignData?.SkipLandingIntro) {
      setUserEmail(authenticatedEmail || '');
      await handleLocationAndOfferArea();
    } else {
      setInvalidInput(true);
    }
  }

  useEffect(() => {
    if (authenticatedEmail) {
      setUserEmail(authenticatedEmail);
      setIsUserAuthenticated(true);
    } else if (query?.email) {
      setUserEmail(String(query.email));
    } else {
      setUserEmail('');
    }
  }, [authenticatedEmail, isUserAuthenticated, campaignData?.SkipLandingIntro]);

  const openRetailerPage = (url: string) => {
    window?.open(url);
  };

  useEffect(() => {
    const loadFontFromUrl = async (url: string) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const fontFamily = campaignData?.Font?.FontFamily || campaignData?.Font?.FontName;

        const selectedFile = new File([blob], fontFamily, { type: blob.type });
        const fontUrl = URL.createObjectURL(selectedFile);
        const fontStyle = {
          fontFamily: fontFamily || '',
          fontSrc: `url(${fontUrl}) format('truetype')`,
          fontWeight: 'normal',
          fontStyle: 'normal',
        };

        setFontStyle(fontStyle);
      } catch (error) {
        console.error('Error loading font:', error);
      }
    };

    if (campaignData?.Font?.FontUrl) {
      loadFontFromUrl(campaignData.Font.FontUrl);
    }
  }, [campaignData, setFontStyle]);

  useEffect(() => {
    const style = document.createElement('style');
    document.head.appendChild(style);

    // Apply @font-face rule based on font family information
    style.innerHTML = `
      @font-face {
        font-family: '${fontStyle?.fontFamily}';
        src: ${fontStyle?.fontSrc};
        font-weight: ${fontStyle?.fontWeight};
        font-style: ${fontStyle?.fontStyle};
      }
      body {
        background-color: ${campaignData.backgroundcolor}
      }
    `;
  }, [fontStyle]);

  if (campaignData.RestrictByReferrer && query.utm_campaign !== campaignData.ValidReferrerString) return <Custom404 />;

  return (
    <>
      {showLandBot && (
        <LandbotComponent
          customChatBotData={customChatBotData}
          campaignData={campaignData}
          isUserAuthenticated={isUserAuthenticated}
        />
      )}

      {showAssociatedCampaignsCompletedModal && (
        <PlainModal
          isOpen={showAssociatedCampaignsCompletedModal}
          onClose={() => {
            setShowAssociatedCampaignsCompletedModal(false);
          }}
          title="Oops!"
          body={`Sorry - it looks like you've already participated in another offer from ${campaignData.BrandName} recently. At this time only one redemption is allowed. Please checkout our other offers <a style="text-decoration: none;" href="/featuredoffers">here.</a>`}
          closeBtnColor={campaignData.ButtonColor}
        />
      )}
      <div className={styles.campaign_screen} style={{ backgroundColor: `${campaignData.backgroundcolor}` }}>
        {!showLandBot && (
          <div className={styles.campaign_container}>
            <Navbar
              campaignData={campaignData}
              filteredRetailers={filteredRetailers}
              userEmail={userEmail}
              isUserAuthenticated={isUserAuthenticated}
              logoWide={campaignData?.EnlargeLogoImage || false}
            />
            <div className={styles.brand_banner}>
              <div className={styles.brand_details}>
                <div className={styles.campagin_details}>
                  <h1
                    className={styles.campaign_header}
                    style={{
                      color: campaignData.HeaderTextColor || campaignData.TextColor || '#000',
                      fontFamily: fontStyle?.fontFamily || '',
                    }}
                  >
                    {campaignData.CampaignHeader}
                  </h1>
                  <p
                    className={styles.campaign_description}
                    style={{
                      color: campaignData.BodyTextColor || campaignData.TextColor || '#000',
                      fontFamily: fontStyle?.fontFamily || '',
                    }}
                    dangerouslySetInnerHTML={{ __html: campaignData.CampaignDescription }}
                  />
                </div>

                <div className={styles.retailers_details}>
                  <div className={styles.bar}>
                    <p
                      style={{ color: `${campaignData.TextColor}` || '#000', fontFamily: fontStyle?.fontFamily || '' }}
                    >
                      Offers Claimed -{' '}
                      <span className={styles.remainingpercent}>{offersClaimed > 100 ? 100 : offersClaimed}%</span>
                    </p>
                    <div className={styles.progressbar}>
                      <div className={styles.progressbar_percentage} style={barStyle}></div>
                    </div>
                  </div>

                  <div className={styles.email_section}>
                    {!authenticatedEmail && !campaignData?.SkipLandingIntro && (
                      <TextField
                        className={`${styles.email_input} ${invalidInput ? styles.emailValidation : ''}`}
                        style={{
                          borderColor: `${campaignData.TextColor}`,
                          color: `${campaignData.TextColor}`,
                          backgroundColor:
                            `${
                              campaignData.backgroundcolor && campaignData.backgroundcolor !== '#ffffff'
                                ? campaignData.TextColor
                                : '#FFFFFF'
                            }` || '#000',
                        }}
                        type="text"
                        value={userEmail}
                        placeholder="Enter Your Email"
                        label=""
                        labelHidden
                        hasError={invalidInput}
                        onChange={(e: any) => {
                          setUserEmail(e.target.value);
                          setInvalidInput(false);
                        }}
                        onKeyPress={(event) => handleEnterKeySubmit(event, submitButtonRef)}
                        title={
                          invalidInput
                            ? `Invalid email: ${userEmail}\nPlease enter a valid email`
                            : 'Enter Your Email Address'
                        }
                      />
                    )}
                    <Button
                      className={
                        !isOfferLive || offerIsOver || isLoading ? styles.submit_button_disabled : styles.submit_button
                      }
                      variation="primary"
                      color={campaignData.ButtonTextColor || '#fff'}
                      backgroundColor={campaignData.ButtonColor}
                      onClick={buttonSubmitHandler}
                      ref={submitButtonRef}
                      disabled={!isOfferLive || offerIsOver || isLoading}
                      style={{
                        ...(fontStyle?.fontFamily ? { fontFamily: fontStyle.fontFamily } : {}),
                        ...(authenticatedEmail || campaignData?.SkipLandingIntro ? { width: '100%' } : {}),
                      }}
                      title={
                        !isOfferLive
                          ? `OFFER STARTS ${new Date(campaignData.StartDate).toLocaleDateString('en-US')}`
                          : offerIsOver
                          ? 'OFFER HAS EXPIRED'
                          : 'GET THIS OFFER'
                      }
                    >
                      {!isOfferLive
                        ? `STARTS ${new Date(campaignData.StartDate).toLocaleDateString('en-US')}`
                        : offerIsOver
                        ? 'OFFER EXPIRED'
                        : 'GET IT NOW!'}
                      {isLoading && (
                        <Loader
                          className={styles.main_btn_loading}
                          size="large"
                          emptyColor={'white'}
                          filledColor={campaignData?.ButtonColor}
                        />
                      )}
                    </Button>
                    {campaignData.DMA.length > 0 && !userInsideOfferArea && (
                      <h4
                        className={`${styles.valid_cities} `}
                        style={{
                          color: `${campaignData.TextColor}` || '#000',
                          fontFamily: fontStyle?.fontFamily || '',
                          fontWeight: 400,
                        }}
                      >
                        Only Valid in these states: {getRegions(campaignData.DMA).join(' ')}
                      </h4>
                    )}
                  </div>

                  {!campaignData.DtcOnly && !('IsSweepstakes' in campaignData && campaignData.IsSweepstakes) && (
                    <div
                      className={styles.retailers_container}
                      style={{
                        fontFamily: fontStyle?.fontFamily || '',
                        color: campaignData.BodyTextColor || campaignData.TextColor || '#000',
                      }}
                      title={
                        campaignData.AllRetailers
                          ? 'Claim @ All Participating Retailers'
                          : 'Claim only @ these retailers'
                      }
                    >
                      <div className={filteredRetailers.length < 3 ? styles.retailers : styles.retailers_carousal}>
                        <div className={styles.particpating_retailers}>
                          {campaignData.AllRetailers ? (
                            <>
                              <i>Claim @ All Participating Retailers</i>
                              <h3>
                                Redeem this offer at{' '}
                                <a href={campaignData.BrandRetailLocationsUrl} target="_blank" rel="noreferrer">
                                  any location the product(s) are available{' '}
                                  {filteredRetailers.some((retailer) => retailer.Name === 'DoorDash')
                                    ? 'including DoorDash'
                                    : '!'}
                                </a>
                              </h3>
                            </>
                          ) : (
                            <>
                              <i>Available @ Select Retailers 👇</i>
                              <Slider {...slick_settings}>
                                {filteredRetailers.map((item, i: number) => (
                                  <Image
                                    key={i}
                                    src={item.LogoUrl || noImage.src}
                                    className={styles.retailer}
                                    alt="logo"
                                    height="80px"
                                    width="80px"
                                    onClick={() =>
                                      openRetailerPage(
                                        item.Id === 'ALL' ? campaignData?.BrandRetailLocationsUrl : item.Url
                                      )
                                    }
                                  />
                                ))}
                              </Slider>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {isDesktopView && (
                <div className={styles.brand_cover_desktop}>
                  <Image
                    className={styles.cover_image}
                    src={campaignData?.BackgroundImage || noImage.src}
                    alt={'Background Image'}
                  />
                </div>
              )}

              {campaignData.ShowStoreLocator &&
                campaignData.BrandRetailLocationsScript &&
                retailerIdQuery == undefined && (
                  <div className={styles.store_locator}>
                    <div id="splash-nav-menu-embed"></div>
                  </div>
                )}

              {!isDesktopView && (
                <div className={styles.brand_cover_mobile}>
                  <Image
                    className={styles.cover_image}
                    src={campaignData?.BackgroundImage || noImage.src}
                    alt={'Background Image'}
                  />
                </div>
              )}
            </div>

            {!('IsSweepstakes' in campaignData && campaignData.IsSweepstakes) && (
              <>
                <div className={styles.steps_header}>
                  <h2
                    style={{
                      fontFamily: fontStyle?.fontFamily || '',
                      color: campaignData.BodyTextColor || campaignData.TextColor || '#000',
                    }}
                  >
                    How it Works
                  </h2>
                </div>
                <div
                  className={styles.steps_container}
                  style={{
                    fontFamily: fontStyle?.fontFamily || '',
                    color:
                      campaignData.BodyTextColor == '#ffffff' || campaignData.TextColor == '255, 255, 255'
                        ? campaignData.backgroundcolor
                        : campaignData.TextColor || '#000',
                  }}
                >
                  <StepCard
                    TextColor={
                      campaignData.BodyTextColor == '#ffffff' || campaignData.TextColor == '255, 255, 255'
                        ? campaignData.backgroundcolor
                        : campaignData.TextColor
                    }
                    ButtonColor={campaignData.ButtonColor}
                    Icon={BagIcon}
                    index={1}
                    TitleText="Get Product"
                    description={
                      campaignData.DtcOnly || campaignData.DtcWithReceipt
                        ? `Purchase product online from the ${campaignData.BrandName} website.`
                        : 'Purchase product in-store (or online with in-store/ curbside pickup) from a participating retailer.'
                    }
                    fontFamily={fontStyle?.fontFamily || ''}
                  />
                  <StepCard
                    TextColor={
                      campaignData.BodyTextColor == '#ffffff' || campaignData.TextColor == '255, 255, 255'
                        ? campaignData.backgroundcolor
                        : campaignData.TextColor
                    }
                    ButtonColor={campaignData.ButtonColor}
                    Icon={PhotoIcon}
                    index={2}
                    TitleText="Share Receipt"
                    description={
                      campaignData.DtcOnly
                        ? 'Share a photo of your digital receipt and/or order number.'
                        : 'Share a photo of your receipt along with the physical product.'
                    }
                    fontFamily={fontStyle?.fontFamily || ''}
                  />
                  <StepCard
                    TextColor={
                      campaignData.BodyTextColor == '#ffffff' || campaignData.TextColor == '255, 255, 255'
                        ? campaignData.backgroundcolor
                        : campaignData.TextColor
                    }
                    ButtonColor={campaignData.ButtonColor}
                    Icon={DollarIcon}
                    index={3}
                    TitleText="Get Cash"
                    description="Get reimbursed via Venmo, or Paypal (usually within 72 hours)!"
                    fontFamily={fontStyle?.fontFamily || ''}
                  />
                </div>
              </>
            )}
            {campaignData.LegalText && (
              <div style={{ width: '100%', padding: '0 0 20px 0' }}>
                <i>*{campaignData.LegalText}</i>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export async function getServerSideProps(context: { params: { id: string }; req: any; res: any }) {
  //get IP info
  let userIp;
  if (context.req.headers['x-forwarded-for']) {
    userIp = context.req.headers['x-forwarded-for'].split(',')[0];
  } else {
    userIp = context.req?.connection?.remoteAddress;
  }
  if (!userIp) {
    let noIpError = {
      name: 'Error',
      message: `Cannot get browser IP for user with email`,
    };
    captureException(noIpError);
  }
  console.log('IP FROM HEADER: ' + userIp);

  supertokens.init(backendConfig());

  let userEmail;

  try {
    const session = await Session.getSession(context.req, context.res, { overrideGlobalClaimValidators: () => [] });
    const userId = session.getUserId();
    const user = await ThirdPartyPasswordlessNode.getUserById(userId);
    userEmail = user?.email;
  } catch (err: any) {
    if (err.type === Session.Error.TRY_REFRESH_TOKEN || err.type === Session.Error.UNAUTHORISED) {
      console.log('Authenticated User Not Found');
      captureException(err);
    }
  }

  try {
    const campaignId = context.params.id;

    const campaignDetailsPromise = getCampaignDetails(client, campaignId, gql);
    const campaignQuestionsPromise = getCampaignQuestions(client, campaignId, gql);

    const [campaignDetails, campaignQuestions] = await Promise.all([campaignDetailsPromise, campaignQuestionsPromise]);

    const campaignData = campaignDetails.data.getCampaign;
    const campaignQuestionsData = campaignQuestions.data.getCampaignQuestions;

    return {
      props: {
        campaignData,
        campaignQuestions: campaignQuestionsData.filter((question: any) => question.IsActive),
        userIp,
        authenticatedEmail: userEmail || null,
      },
    };
  } catch (err: any) {
    captureException(err);
    return { notFound: true, props: { error: err } };
  }
}

interface PropTypes {
  campaignData: ICampaign;
  campaignQuestions: ICampaignCustomQuestion[];
  userIp?: string | undefined;
  authenticatedEmail?: string | null;
}

export default Campaigns;
